import { render, staticRenderFns } from "./orderInfoQry.vue?vue&type=template&id=0c59f832&scoped=true"
import script from "./orderInfoQry.vue?vue&type=script&lang=js"
export * from "./orderInfoQry.vue?vue&type=script&lang=js"
import style0 from "./orderInfoQry.vue?vue&type=style&index=0&id=0c59f832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59f832",
  null
  
)

export default component.exports